export default "__VITE_ASSET__CKIPPta5__"